export default __webpack_public_path__ + "static/media/a1.2e1376ad.png";